var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.17,
    height: 13.318,
    viewBox: "0 0 13.17 13.318",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_100-2-2",
    "data-name": "Trazado 100-2-2",
    d: "M2.345,19.584V12.809L0,12.852,6.585,6.267l6.585,6.585-2.3-.042v6.775H8.286V15.453H4.905v4.132Z",
    transform: "translate(0 -6.267)",
    fill: "#2f2f2f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoHome);
export default __webpack_public_path__ + "static/media/Icono_home.911a5fe264df7fe4d1a9bacfe42f7851.svg";
export { ForwardRef as ReactComponent };